import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { forkJoin } from "rxjs";
import { filter } from "rxjs/operators";
import { FilterModel } from "src/app/shared/components/filter/model/filter.model";
import { Column } from "src/app/shared/components/table/model/column";
import { Table } from "src/app/shared/components/table/model/table";
import { TableUtilityService } from "src/app/shared/components/table/service/utility/table-utility.service";
import { SearchParams } from "src/app/shared/model/searchParams";
import { TableApiService } from "src/app/shared/service/api/table-api.service";
import { HierarchyManagementService } from "src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service";
import { ProfileManagementService } from "src/app/shared/service/store-management/profile-management/profile-management.service";

import { SubSink } from "subsink";
import { CommercialRolesRequest } from "../model/sales-choose.model";
import { SalesChooseMapService } from "../service/map/sales-choose-map.service";
import { SalesChooseService } from "../service/sales-choose.service";
import { FileUtilService } from "src/app/shared/service/file-util/file-util.service";
import { MimeTypes } from "src/app/shared/components/upload-file-dnd/model/mimeTypes";
import { DateUtilService } from "src/app/shared/service/date-util/date-util.service";
import { FilterComponent } from "src/app/shared/components/filter/filter.component";
import { TableComponent } from "src/app/shared/components/table/table.component";

@Component({
  selector: "ald-sales-choose-table",
  templateUrl: "./sales-choose-table.component.html",
  styleUrls: ["./sales-choose-table.component.scss"],
  standalone: true,
  imports: [
    FilterComponent,
    TableComponent
  ]
})
export class SalesChooseTableComponent implements OnInit, OnChanges {
  @Input() salesSelected;
  searchParams: SearchParams;
  table: Table = {} as Table;
  filters: FilterModel;
  appliedFilters = {} as CommercialRolesRequest;
  page = "sales";
  private subs: SubSink = new SubSink();
  columns: Array<Column>;
  @Output() selectedSales = new EventEmitter();
  constructor(
    private salesChooseService: SalesChooseService,
    private tableApi: TableApiService,
    private tableUtility: TableUtilityService,
    private salesChooseMapService: SalesChooseMapService,
    private profileManagement: ProfileManagementService,
    private hierarchyManagementService: HierarchyManagementService,
    private fileUtil: FileUtilService,
    private dateUtil: DateUtilService,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.salesSelected) {
      this.defineSearchParams();
      this.initTable();
    }
  }

  initTable(): void {
    // tslint:disable-next-line: variable-name
    const $list_vehicle_table_api = [
      this.tableApi.getFilters(this.page),
      this.tableApi.getColumnsByName(`sales-list`),
    ];
    this.subs.add(
      forkJoin($list_vehicle_table_api)
        .pipe(filter((res) => !!res))
        .subscribe((forkedRes: any) => {
          const { salesFilters } = forkedRes[0];
          this.filters = this.tableUtility.getDefaultFilterModel(salesFilters);
          const { commercialRolesListColumns } = forkedRes[1];
          this.columns = this.tableUtility.prepareToTranslation(
            commercialRolesListColumns
          );
          this.searchCustomers();
        })
    );
  }

  private searchCustomers(): void {
    this.subs.add(
      this.salesChooseService
        .commercialRoles(this.searchParams, this.appliedFilters)
        .pipe(filter((res) => !!res))
        .subscribe((resp: any) => {
          const { totElements, commercialRoles } = resp;
          this.loadTable(this.columns, commercialRoles, totElements);
        })
    );
  }

  private loadTable(
    columns: Array<Column>,
    data: Array<any>,
    totalElements: number
  ): void {
    this.table = {} as Table;
    this.table = this.tableUtility.getResponseToTable(
      columns,
      this.salesChooseMapService.salesChooseMap(data),
      totalElements
    );
  }

  private defineSearchParams(): void {
    this.appliedFilters.salesRef = this.salesSelected;
    this.searchParams = {
      page: 1,
      pageSize: 5,
    };
  }

  selectionCustomer(row) {
    const customerChoosen = row.customerChoosen;
    if (!!customerChoosen) {
      const profile = this.profileManagement.getProfileByStore();
      profile.customerId = customerChoosen.customerId;
      profile.customerReference = customerChoosen.customerReference;
      profile.customerName = customerChoosen.tradingName;
      profile.isCorporateQuoterEnabled = customerChoosen.corporateQuoteEnable;
      profile.isCarSharing = customerChoosen.isCarSharing;
      profile.isConsumer = customerChoosen.isConsumer;
      profile.isRoot = customerChoosen.isRoot;
      this.restoreHierarchy(profile);
      this.profileManagement.setProfileInStore(profile);
      sessionStorage.setItem("profile", JSON.stringify(profile));
      this.selectedSales.emit(true);
    }
  }

  restoreHierarchy(profile) {
    this.hierarchyManagementService.setHierarchyRefsSelected([]);
    this.hierarchyManagementService.setHierarchyRefsSelected([
      profile.customerReference,
    ]);
    this.hierarchyManagementService.setHierarchyIdsSelected([]);
    this.hierarchyManagementService.setHierarchyIdsSelected([
      profile.customerId,
    ]);
  }

  onPageChangeEvent(pageSelected): void {
    this.searchParams.page = pageSelected;
    this.searchCustomers();
  }

  onSortSelected(sortSelected): void {
    this.searchParams.orderBy = sortSelected.active;
    this.searchParams.asc = sortSelected.direction === "asc";
    this.searchCustomers();
  }

  search(resFilter): void {
    this.appliedFilters.searchGuid = resFilter.searchGuid;
    //this.appliedFilters.active = resFilter.status?.some((x) => x === "active");
    //this.appliedFilters.customerRef = JSON.stringify(
    //this.csmanagementService.getCustomerServiceByStore().customer_id
    // );
    //this.appliedFilters.customerId = resFilter.customerId;
    this.searchParams.page = 1;
    this.searchCustomers();
  }

  onExportCommercialRoleList(isFiltered): void{
      const body = isFiltered
      ? this.appliedFilters
      : ({
        salesRef: this.salesSelected,
        searchGuid: null,
      } as any);
    const searchParamsExport = {
      ...this.searchParams,
    } as SearchParams;
    delete searchParamsExport.page;
    delete searchParamsExport.pageSize;
    this.subs.add(
      this.salesChooseService
        .commercialRolesExport(searchParamsExport, body)
        .pipe(filter((res) => !!res))
        .subscribe((data) =>
          this.fileUtil.downloadFile(
            data,
            MimeTypes.excel,
            `commercialRolesList_${this.dateUtil.getNowFormatted(
              "DD_MM_YYYY_hh_mm"
            )}.xlsx`
          )
        )
    );
  }
}
